import { ItemType } from 'app/modules/Constants';
import { FC } from 'react';
import { connect } from 'react-redux';
import { toggleEnableReturnLocation } from '../../../actions/carActions';
import TabBarSelect from '../Common/TabBarSelect';

const items: ItemType[] = [
	{
		label: 'main.cars.sameDropOff',
		value: 'same',
	},
	{
		label: 'main.cars.differentDropOff',
		value: 'different',
	},
];

type DropOffTypeSelectorProps = {
	enableReturnLocation: boolean;
	toggleEnableReturnLocation: (toggle: boolean) => void;
};

const DropOffTypeSelector: FC<DropOffTypeSelectorProps> = (props) => {
	const onSelect = (item: ItemType) => {
		if (item.value === 'same') {
			props.toggleEnableReturnLocation(false);
		} else {
			props.toggleEnableReturnLocation(true);
		}
	};

	return (
		<div>
			<TabBarSelect onSelect={onSelect} items={items} selectedItem={props.enableReturnLocation ? items[1] : items[0]} />
		</div>
	);
};

// @ts-ignore
const mapStateToProps = (state) => ({
	enableReturnLocation: state.car.enableReturnLocation,
});

export default connect(mapStateToProps, { toggleEnableReturnLocation })(DropOffTypeSelector);
